<template>
<b-tab lazy title-item-class="mr-1" :title-link-class="{'bg-danger': hasErrors, 'bg-warning': isDirty}">
    <template slot="title">
        <i v-if="isDirty || hasErrors" class="fa-solid fa-circle-exclamation" :class="{ 'fa-circle-exclamation text-white': hasErrors, 'fa-cloud-arrow-up text-black': isDirty}"></i> CBB formulier
    </template>
    <cbbformulier-base button-top small fixed :callback="createPatientAdminCbbFormulier" />
</b-tab>
</template>
<script>
import TabExtension from "../TabExtension"
import CbbFormulierBase from "@/core/components/health/cbbformulier/CbbFormulierBase"
import { mapActions } from "vuex"

export default TabExtension.extend({
    name: "cbbformulier",
    components: {
        'cbbformulier-base': CbbFormulierBase
    },
    methods: {
        ...mapActions('health', ['createPatientAdminCbbFormulier']),
    }
})
</script>
